import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { ISelectModel } from 'common/models';
import API from 'services/api';

const ROOT_CURRENCIES = 'ROOT_CURRENCIES';

const getCurrencies = (): Promise<ISelectModel<number>[]> =>
  API.get('/api/root/currencies/all').then(response => response.data);

export const useCurrenciesQuery = () => {
  const { data: currencies, ...rest } = useQuery(
    ROOT_CURRENCIES,
    getCurrencies,
    getCacheSettings(),
  );

  return {
    ...rest,
    currencies,
  };
};
